export default {
	SELECTED: '--brand--blue',
	HIGHLIGHTED: '--green-200'
};
